// Path scheme for the public, shareable athlete / coach profile page. A single
// place builds and parses `/p/:token` so the share/copy link and the
// client-side route resolver (`main.tsx`) always agree. The token is the
// athlete's opaque profile token (never the personal number). Kept
// framework-free so it can be unit-tested in isolation, mirroring `sharePath.ts`.

const PREFIX = '/p/';

/** In-app path for a profile's public view, e.g. "/p/Profile_abc". */
export function publicProfilePath(profileToken: string): string {
  return `${PREFIX}${encodeURIComponent(profileToken)}`;
}

/**
 * Extract the profile token from a public-profile pathname, or null when the
 * path is not a public-profile route. Accepts an optional trailing slash and
 * rejects extra path segments so only `/p/<token>` resolves.
 */
export function parsePublicProfilePath(pathname: string): string | null {
  if (!pathname.startsWith(PREFIX)) return null;
  const rest = pathname.slice(PREFIX.length).replace(/\/+$/, '');
  if (rest.length === 0 || rest.includes('/')) return null;
  try {
    const token = decodeURIComponent(rest);
    return token.length > 0 ? token : null;
  } catch {
    return null; // malformed percent-encoding
  }
}

/** Absolute share URL (origin + path) used by the copy button / QR code. */
export function publicProfileUrl(profileToken: string, origin: string): string {
  return `${origin}${publicProfilePath(profileToken)}`;
}
